import Reflux from "reflux";
import Actions from "./PerformanceEditorActions";

const defaultState = {
  performanceMediaAssets: [],
  isDeletingMediaAsset: false,
  isFetchingPerformanceMediaAsset: false
};

export default class PerfomanceEditorStore extends Reflux.Store {
  constructor(props) {
    super(props);

    this.state = Object.assign({}, defaultState);

    this.listenables = Actions;
  }

  onGetMultipleMediaAssetByIds() {
    this.setState({ isFetchingPerformanceMediaAsset: true });
  }

  onGetMultipleMediaAssetByIdsCompleted({ payload }) {
    const newPerformanceMediaAssets = payload.mediaAssets;

    this.setState({
      performanceMediaAssets: newPerformanceMediaAssets || [],
      isFetchingPerformanceMediaAsset: false
    });
  }

  onGetMultipleMediaAssetByIdsFailed() {
    this.setState({ isFetchingPerformanceMediaAsset: false });
  }

  onDeleteMultipleMediaAssets() {
    this.setState({ isDeletingMediaAsset: true });
  }

  onDeleteMultipleMediaAssetsCompleted() {
    this.setState({ isDeletingMediaAsset: false });
  }

  onDeleteMultipleMediaAssetsFailed() {
    this.setState({ isDeletingMediaAsset: false });
  }
}
